export class ApprovalPortalService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? ApprovalPortalService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${ApprovalPortalService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    async getPending() {
        const response = await this.http.get(this.buildUrl('pending'));
        return response.data ?? [];
    }
    async approve(requestId) {
        const response = await this.http.put(this.buildUrl(`${requestId}/approve`), {});
        return response.data;
    }
    async reject(requestId, reason) {
        const response = await this.http.put(this.buildUrl(`${requestId}/reject`), { reason });
        return response.data;
    }
    async getHistory() {
        const response = await this.http.get(this.buildUrl('history'));
        return response.data ?? [];
    }
    async getView(requestId) {
        const response = await this.http.get(this.buildUrl(`${requestId}`));
        return response.data;
    }
}
ApprovalPortalService.DEFAULT_SERVICE_PATH = 'procurements';
ApprovalPortalService.BASE_PATH = 'api/procurement-portal/approval';
//# sourceMappingURL=ApprovalPortalService.js.map